import React, { useContext } from "react";
import { AuthContext } from "../AuthProvider";
import HotWaterTimes from "../components/hotwater/HotWaterTimes";
import HotWaterStart from "../components/hotwater/HotWaterStart";
import HotWaterLowPrice from "../components/hotwater/HotWaterLowPrice";
import CombinedSchedule from "../components/controlpanel/CombinedSchedule";
import ControlPanelMenu from "../components/controlpanel/ControlPanelMenu";

const Hotwater = () => {

    const { esp, espLoading } = useContext(AuthContext);

    return (
        <div className="detail-container">
            <ControlPanelMenu />
            <div className="card p-1">
                <div>
                    <h1 className="m-3">Varmvatten</h1>
                </div>
                <div>
                    {!espLoading && !esp && <p>Du har ingen styrenhet kopplad till ditt kundkonto.</p>}
                    {esp && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <HotWaterStart />
                                    <HotWaterLowPrice />
                                    <HotWaterTimes />
                                </div>
                            </div>
                            {esp.hotWater?.heatNow && (<div className="border rounded bg-warning m-1 mt-2">
                                <div className="d-flex align-items-center p-1">
                                    <i className="bi bi-fire m-2 text-dark"></i>
                                    <span className="text-dark align-baseline pt-3">
                                        <p>{`Värm nu pågår till vattnet nått ${esp?.hotWater?.metrics?.maxTemp}°C eller i en timme. Nuvarande temperatur är ${esp?.sensorData?.hotWaterTemp?.toFixed(1)}°C.`}</p>
                                    </span>
                                </div>
                            </div>
                            )
                            }
                            <CombinedSchedule showOnlyHotWater={true} />
                        </>
                    )}
                </div>
            </div>
        </div >
    )
}

export default Hotwater;


